import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900`;
const Text = styled.div`
  ${tw`text-lg text-gray-800`}
  p {
    ${tw`mt-2 leading-loose text-sm`}
  }
  h1 {
    ${tw`text-2xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-xl font-semibold mt-8`}
  }
  h3 {
    ${tw`text-lg mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;

export default ({ headingText = "Privacy Policy" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <div className="w-[90%] m-auto">
          <ContentWithPaddingXl>
            <HeadingRow>
              <Heading>{headingText}</Heading>
            </HeadingRow>
            <Text>
              <h1>Section 1 - What Do We Do With Your Information?</h1>

              <p>
                When you purchase something from our store, as part of the buying
                and selling process, we collect the personal information you give
                us such as your name, address and email address.
              </p>

              <p>
                When you browse our store, we also automatically receive your
                computer’s internet protocol (IP) address in order to provide us
                with information that helps us learn about your browser and
                operating system.
              </p>

              <p>
                Email marketing (if applicable): With your permission, we may send
                you emails about our store, new products and other updates.
              </p>

              <h1>Section 2 - Consent</h1>
              <h2>How Do You Get My Consent?</h2>
              <p>
                When you provide us with personal information to complete a
                transaction, verify your credit card, place an order, arrange for
                a delivery or return a purchase, we imply that you consent to our
                collecting it and using it for that specific reason only.
              </p>
              <p>
                If we ask for your personal information for a secondary reason,
                like marketing, we will either ask you directly for your expressed
                consent, or provide you with an opportunity to say no.
              </p>

              <h2>How Do I Withdraw My Consent?</h2>
              <p>
                If after you opt-in, you change your mind, you may withdraw your
                consent for us to contact you, for the continued collection, use
                or disclosure of your information, at any time, by contacting us at
                helpyourselfgoals@gmail.com or mailing us at: Nanal Nagar Khader
                Bagh Premier Hospital Hyderabad Telangana 500008
              </p>

              <h1>Section 3 - Disclosure</h1>
              <p>
                We may disclose your personal information if we are required by
                law to do so or if you violate our terms of service.
              </p>

              <h1>Section 4 - Payment</h1>
              <p>
                We use Razorpay for processing payments. We/Razorpay do not store
                your card data on their servers. The data is encrypted through the
                Payment Card Industry Data Security Standard (PCI-DSS) when
                processing payment. Your purchase transaction data is only used as
                long as is necessary to complete your purchase transaction. After
                that is complete, your purchase transaction information is not
                saved.
              </p>

              <p>
                Our payment gateway adheres to the standards set by PCI-DSS as
                managed by the PCI Security Standards Council, which is a joint
                effort of brands like Visa, MasterCard, American Express and
                Discover.
              </p>

              <p>
                PCI-DSS requirements help ensure the secure handling of credit
                card information by our store and its service providers.
              </p>
              <p>
                For more insight, you may also want to read terms and conditions
                of Razorpay on https://razorpay.com
              </p>

              <h1>Section 5 - Third-Party Services</h1>
              <p>
                In general, the third-party providers used by us will only
                collect, use and disclose your information to the extent necessary
                to allow them to perform the services they provide to us.
              </p>
              <p>
                However, certain third-party service providers, such as payment
                gateways and other payment transaction processors, have their own
                privacy policies in respect to the information we are required to
                provide to them for your purchase-related transactions.
              </p>
              <p>
                For these providers, we recommend that you read their privacy
                policies so you can understand the manner in which your personal
                information will be handled by these providers.
              </p>
              <p>
                In particular, remember that certain providers may be located in
                or have facilities that are located in a different jurisdiction than
                either you or us. So if you elect to proceed with a transaction
                that involves the services of a third-party service provider, then
                your information may become subject to the laws of the
                jurisdiction(s) in which that service provider or its facilities
                are located.
              </p>

              <p>
                Once you leave our store’s website or are redirected to a
                third-party website or application, you are no longer governed by
                this privacy policy or our website’s terms of service.
              </p>

              <h2>Links</h2>
              <p>
                When you click on links on our store, they may direct you away
                from our site. We are not responsible for the privacy practices of
                other sites and encourage you to read their privacy statements.
              </p>

              <h1>Section 6 - Security</h1>
              <p>
                To protect your personal information, we take reasonable
                precautions and follow industry best practices to make sure it is
                not inappropriately lost, misused, accessed, disclosed, altered or
                destroyed.
              </p>

              <h1>Section 7 - Cookies</h1>
              <p>
                We use cookies to maintain a session of your user. It is not used to
                personally identify you on other websites.
              </p>

              <h1>Section 8 - Age of Consent</h1>
              <p>
                By using this site, you represent that you are at least the age of
                majority in your state or province of residence, or that you are
                the age of majority in your state or province of residence and you
                have given us your consent to allow any of your minor dependents
                to use this site.
              </p>

              <h1>Section 9 - Changes to This Privacy Policy</h1>
              <p>
                We reserve the right to modify this privacy policy at any time, so
                please review it frequently. Changes and clarifications will take
                effect immediately upon their posting on the website. If we make
                material changes to this policy, we will notify you here that it
                has been updated, so that you are aware of what information we
                collect, how we use it, and under what circumstances, if any, we
                use and/or disclose it.
              </p>
              <p>
                If our store is acquired or merged with another company, your
                information may be transferred to the new owners so that we may
                continue to sell products to you.
              </p>

              <h2>Questions and Contact Information</h2>
              <p>
                If you would like to: access, correct, amend or delete any
                personal information we have about you, register a complaint, or
                simply want more information contact our privacy compliance
                officer at helpyourselfgoals@gmail.com or by mail at Nanal Nagar
                Khader Bagh Premier Hospital Hyderabad Telangana 500008
              </p>
            </Text>
          </ContentWithPaddingXl>
        </div>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
